import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const categoryLinks = [
    { to: '/category/guobiao-majiang', label: '国标麻将' },
    { to: '/category/sichuan-majiang', label: '四川麻将' },
    { to: '/category/guangdong-majiang', label: '广东麻将' },
    { to: '/category/majiang-jiqiao', label: '麻将技巧' },
    { to: '/category/majiang-wenhua', label: '麻将文化' },
    { to: '/category/xinshou-rumen', label: '新手入门' },
  ];

  const quickLinks = [
    { to: '/', label: t('nav.home') },
    { to: '/category/guobiao-majiang', label: t('nav.categories') },
    { to: '/about', label: t('nav.about') },
  ];

  return (
    <footer className="bg-foreground-900 text-white/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 text-xl font-heading font-bold text-white mb-4 whitespace-nowrap">
              <i className="ri-stack-line text-2xl"></i>
              <span>{t('site.name')}</span>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              {t('footer.description')}
            </p>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4">{t('footer.categories')}</h4>
            <ul className="space-y-2.5">
              {categoryLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-white/60 hover:text-white transition-colors duration-200 whitespace-nowrap">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-heading font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-2.5 text-sm text-white/60">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@majiangzaxianwan.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>中国北京市朝阳区</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">{t('footer.copyright')}</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 hover:text-white transition-colors duration-200" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-white/40 hover:text-white transition-colors duration-200" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}